import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllAssetsOption = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 9999,
  location = [],
  category = [],
  status = "",
  serialNumber = "",
  placedDate = [],
  sort = [],
  role,
  allIds,
  fromAsset = false
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
    $and: [],
  };

  const statusConditions = [];

  if (status) {
    statusConditions.push(
      { status: { $eq: status } },
      { childAssets: { status: { $eq: status } } },
      { grandChildAssets: { status: { $eq: status } } }
    );
  }

  if (searchName == "all_asset") {
    assetFilters.isChild = {
      $eq: false,
    };
  } else if (searchName) {
    assetFilters.$or = [
      {
        name: {
          $containsi: searchName,
        },
      },

      {
        countId: {
          $containsi: searchName,
        },
      },
    ];
  } else {
    assetFilters.isChild = {
      $eq: false,
    };
  }

  if (statusConditions.length > 0) {
    assetFilters.$and.push({ $or: statusConditions });
  }

  if (assetFilters.$and.length > 0) {
    assetFilters = { $and: [assetFilters] };
  } else {
    assetFilters = { $and: [assetFilters] };
  }

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,
    locations: location,
    status,

    populate: [
      "childAssets.parentAsset",
      "storedAssets.grandChildAsset.createdByUser",

      "grandChildAssets.parentAsset",

      "location",
      "storedAssets.childAsset.location",
      "childAssets.location",
      "storedAssets.childAsset.grandChildAssets",
      "storedAssets.childAsset.grandChildAssets.location",
      "childAssets.grandChildAssets",
      "storedAssets.grandChildAsset.location",
      "storedAssets.grandChildAsset.childAssets",

      "grandChildAssets.location",
      "grandChildAssets.childAssets",
      "storedAssets",
      "childAssets",
      "parentAsset",
      "grandChildAssets",
      "grandChildAssets.childAssets",
      "storedAssets.childAsset",

      "storedAssets.grandChildAsset",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }
  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `assets?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getAllAssets = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 9999,
  location = [],
  category = [],
  status = "",
  serialNumber = "",
  placedDate = [],
  sort = [],
  role,
  allIds,
  fromAsset = false
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
    $and: [],
  };

  if (searchName == "all_asset") {
    assetFilters.status = {
      $ne: "dispose",
    };
  }

  const statusConditions = [];
  if (status) {
    statusConditions.push(
      { status: { $eq: status } },
      { childAssets: { status: { $eq: status } } },
      { grandChildAssets: { status: { $eq: status } } }
    );
  }

  if (searchName == "all_asset") {
  } else if (searchName) {
    assetFilters.$or = [
      {
        name: {
          $containsi: searchName,
        },
      },
      {
        countId: {
          $containsi: searchName,
        },
      },
    ];
  } else {
    assetFilters.isChild = {
      $eq: false,
    };
  }
  const categoryConditions = [];
  if (category?.length > 0) {
    categoryConditions.push(
      { categories: { id: { $in: category } } },
      { childAssets: { categories: { id: { $in: category } } } },
      { grandChildAssets: { categories: { id: { $in: category } } } }
    );
  }

  const placedDateConditions = [];
  if (placedDate.length === 1) {
    placedDateConditions.push(
      { placedDate: { $gte: placedDate[0] } },
      { childAssets: { placedDate: { $gte: placedDate[0] } } },
      { grandChildAssets: { placedDate: { $gte: placedDate[0] } } }
    );
  } else if (placedDate.length === 2) {
    placedDateConditions.push(
      { placedDate: { $gte: placedDate[0], $lte: placedDate[1] } },
      {
        childAssets: {
          placedDate: { $gte: placedDate[0], $lte: placedDate[1] },
        },
      },
      {
        grandChildAssets: {
          placedDate: { $gte: placedDate[0], $lte: placedDate[1] },
        },
      }
    );
  }

  const serialNumberConditions = [];
  if (serialNumber) {
    serialNumberConditions.push(
      { serialNumber: { $eq: serialNumber } },
      { childAssets: { serialNumber: { $eq: serialNumber } } },
      { grandChildAssets: { serialNumber: { $eq: serialNumber } } }
    );
  }
  if (serialNumberConditions.length > 0) {
    assetFilters.$and.push({ $or: serialNumberConditions });
  }

  if (assetFilters.$and.length > 0) {
    assetFilters = { $and: [assetFilters] };
  } else {
    assetFilters = { $and: [assetFilters] };
  }

  let startPlacedDate;
  let endPlacedDate;
  if (placedDate?.length === 1) {
    startPlacedDate = placedDate[0];
  } else if (placedDate?.length === 2) {
    startPlacedDate = placedDate[0];
    endPlacedDate = placedDate[1];
  }

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,
    status,
    categories: category,
    locations: location,
    startPlacedDate,
    endPlacedDate,

    populate: [
      "image",
      "storedAssets.childAsset.image",
      "childAssets.image",
      "grandChildAssets.image",
      "childAssets.peoples",
      "grandChildAssets.peoples",

      "childAssets.peoples.dispose",
      "grandChildAssets.peoples.dispose",
      "childAssets.peoples.profileImage",
      "childAssets.teams",
      "grandChildAssets.peoples.profileImage",
      "childAssets.warrantyFile",
      "grandChildAssets.teams",
      "storedAssets.grandChildAsset.image",
      "peoples",
      "storedAssets.childAsset.peoples",
      "storedAssets.grandChildAsset.peoples",

      "dispose",
      "storedAssets.childAsset.dispose",
      "storedAssets.grandChildAsset.dispose",
      "peoples.profileImage",
      "storedAssets.childAsset.peoples.profileImage",
      "storedAssets.grandChildAsset.peoples.profileImage",
      "teams",
      "storedAssets.childAsset.teams",
      "storedAssets.grandChildAsset.teams",
      "warrantyFile",
      "storedAssets.childAsset.warrantyFile",
      "storedAssets.grandChildAsset.warrantyFile",
      "grandChildAssets.warrantyFile",
      "createdByUser",
      "storedAssets.childAsset.createdByUser",
      "childAssets.createdByUser",
      "storedAssets.childAsset.parentAsset",
      "childAssets.parentAsset",
      "storedAssets.grandChildAsset.createdByUser",
      "grandChildAssets.createdByUser",

      "grandChildAssets.parentAsset",
      "updatedByUser",
      "storedAssets.childAsset.updatedByUser",
      "childAssets.updatedByUser",
      "storedAssets.grandChildAsset.updatedByUser",
      "grandChildAssets.updatedByUser",
      "vendor.logo",
      "storedAssets.childAsset.vendor.logo",
      "childAssets.vendor.logo",
      "storedAssets.grandChildAsset.vendor.logo",
      "grandChildAssets.vendor.logo",
      "customer.logo",
      "storedAssets.childAsset.customer.logo",
      "childAssets.customer.logo",
      "storedAssets.grandChildAsset.customer.logo",
      "grandChildAssets.customer.logo",
      "vendor",
      "storedAssets.childAsset.vendor",
      "childAssets.vendor",
      "storedAssets.grandChildAsset.vendor",
      "grandChildAssets.vendor",
      "parts",
      "storedAssets.childAsset.parts",
      "storedAssets.grandChildAsset.parts",
      "customer",
      "storedAssets.childAsset.customer",
      "childAssets.customer",
      "storedAssets.grandChildAsset.customer",
      "grandChildAssets.customer",
      "procedure",
      "storedAssets.childAsset.procedure",
      "childAssets.procedure",
      "storedAssets.grandChildAsset.procedure",
      "grandChildAssets.procedure",

      "categories",
      "storedAssets.childAsset.categories",
      "childAssets.categories",
      "storedAssets.grandChildAsset.categories",

      "grandChildAssets.categories",
      "grandChildAssets.createdByUser.profileImage",

      "location",
      "storedAssets.childAsset.location",
      "childAssets.location",
      "storedAssets.childAsset.grandChildAssets",
      "storedAssets.childAsset.grandChildAssets.location",
      "childAssets.grandChildAssets",
      "storedAssets.grandChildAsset.location",
      "storedAssets.grandChildAsset.childAssets",

      "area",
      "storedAssets.childAsset.area",
      "storedAssets.grandChildAsset.area",
      "grandChildAssets.location",
      "grandChildAssets.childAssets",
      "childAssets.parts",
      "grandChildAssets.parts",
      "childAssets.area",
      "grandChildAssets.area",
      "storedAssets",
      "childAssets",
      "parentAsset",
      "grandChildAssets",
      "grandChildAssets.childAssets",
      "storedAssets.childAsset",

      "storedAssets.grandChildAsset",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }
  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `assets?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const updateAsset = async (
  id,
  name,
  description,
  model,
  category,
  area,
  serialNumber,
  barcode,
  vendor,
  customer,
  placedDate,
  warrantyExpirationDate,
  additionalInformation,
  image,
  warrantyFile,
  qrcode,
  procedure = null,
  location = null,
  subLocations = null,
  purchasePrice,
  manufacturer,
  descriptionRate,
  estimatedUsefulLife,
  peoples,
  teams,
  organisation,
  isChild,
  parentAsset
) => {
  try {
    let params = {
      name,
      description,
      model,
      categories: category,
      area,
      serialNumber,
      barcode,
      vendor,
      customer,
      placedDate,
      warrantyExpirationDate,
      additionalInformation,
      image,
      warrantyFile,
      qrcode,
      procedure,
      location,
      subLocations,
      purchasePrice,
      manufacturer,
      descriptionRate,
      estimatedUsefulLife,
      peoples,
      teams,
      organisation,
      isChild,
      parentAsset,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "assets/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};
